import { generateSourcesForPicture } from '@farmersdog/corgi-x';

import shouldBeFoodJpg from './should-be-food.jpg';
import shouldBeFoodWebP from './should-be-food.webp';

import dentalDiseaseGraphPng from './dental-disease-graph.png';
import dentalDiseaseGraphWebP from './dental-disease-graph.webp';
import dentalDiseaseGraphJp2 from './dental-disease-graph.jp2';

export const shouldBeFoodSources = generateSourcesForPicture({
  desktopSources: { webP: shouldBeFoodWebP, jpg: shouldBeFoodJpg },
  mobileSources: { webP: shouldBeFoodWebP, jpg: shouldBeFoodJpg },
});

export const dentalDiseaseSources = generateSourcesForPicture({
  desktopSources: {
    webP: dentalDiseaseGraphWebP,
    jpg: dentalDiseaseGraphJp2,
    png: dentalDiseaseGraphPng,
  },
  mobileSources: {
    webP: dentalDiseaseGraphWebP,
    jpg: dentalDiseaseGraphJp2,
    png: dentalDiseaseGraphPng,
  },
});
